import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { PopupWidget } from 'react-calendly';
import { useEffect, useState } from 'react';

const Contact = () => {
  const { t } = useTranslation('contact');
  const [rootElement, setRootElement] = useState(null as any);

  useEffect(() => {
    const el = document.getElementById('__next');
    setRootElement(el);
  }, []);

  return (
    <>
      <Head>
        <meta name="description" content="Contact me - Eloïc Ah-hing" />
      </Head>
      <div className="fade-in divide-y-2 divide-gray-100 dark:divide-gray-800">
        <div className="space-y-2 pt-6 pb-8 md:space-y-5">
          <h1 className="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14">
            {t('contact')}
          </h1>
        </div>
        <div className="container py-12" id="root">
          <p>{t('contactdescription')}</p>
        </div>
      </div>
      <PopupWidget
        url="https://calendly.com/eloic8/30min"
        rootElement={rootElement}
        text={t('clickheretoschedule')}
        textColor="#ffffff"
        color="#00a2ff"
      />
    </>
  );
};

export const getStaticProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ['contact']))
  }
});

export default Contact;
